<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-2">

            <!-- Card stats -->
            <div class="row pt-md-4">
                <div class="col-md-12">
                    <h1>CRC32</h1>
                </div>

                <div class="col-xl-6 col-lg-6">
                    <div class="form-group">
                        <input type="text" class="form-control input-group" v-model="values.input"
                               placeholder="Enter Text ASCII Value"/>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6">
                    <div class="form-group">
                        <input type="text" class="form-control input-group" v-model="values.output"
                               placeholder="Result CRC32"/>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xl-12 col-lg-12">
                    <button class="btn btn-dark" @click="calc"><i class="ni ni-sound-wave"></i> Convert</button>
                    <button class="btn btn-primary" @click="clean"><i class="ni ni-button-power"></i> Clear
                    </button>
                    <button v-if="values.output" class="btn btn-info"
                            v-clipboard:copy="values.output"
                            v-clipboard:success="onCopy">
                        <i class="ni ni-ungroup"></i> Copy
                    </button>
                </div>


                <div class="col-xl-6 col-lg-6">
                    <div class="form-group col-md-6 mt-2 mb-0 bg-secondary rounded">
                        <label>Output Data</label><br/>
                        <input v-model="select.out" id="selectDec" type="radio" name="selectOut" checked
                               value="d"> <label for="selectDec">DEC</label>
                        <input v-model="select.out" class="ml-4" id="selectHex" type="radio" name="selectOut" value="h"> <label
                            for="selectHex">HEX</label>
                    </div>
                </div>


            </div>

        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--8 bg-dark pb-4">

            <!--Tables-->
            <div class="row mt-5">
                <div class="col-xl-12 mb-12 mb-xl-12">
                    <div class="card">
                        <div class="card-header border-0">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h3 class="mb-0">Latest Results</h3>
                                </div>
                                <div class="col text-right">
                                    Local Data
                                </div>
                            </div>
                        </div>

                        <div class="table-responsive">
                            <base-table thead-classes="thead-light"
                                        :data="tableData">
                                <template slot="columns">
                                    <th>In</th>
                                    <th>Input Data</th>
                                    <th>Out</th>
                                    <th>Output Data</th>

                                </template>

                                <template slot-scope="{row}">
                                    <th scope="row">
                                        <button class="btn btn-sm"
                                                v-clipboard:copy="row.input"
                                                v-clipboard:success="onCopy">
                                            {{row.inType}} <i class="ni ni-ungroup"></i>
                                        </button>
                                    </th>
                                    <th scope="row">
                                        {{row.input}}
                                    </th>
                                    <td>
                                        <button class="btn btn-sm"
                                                v-clipboard:copy="row.output"
                                                v-clipboard:success="onCopy">
                                            {{row.outType}} <i class="ni ni-ungroup"></i>
                                        </button>
                                    </td>
                                    <td style="overflow-x:auto;">
                                        {{row.output}}
                                    </td>

                                </template>

                            </base-table>
                        </div>

                    </div>

                </div>
            </div>
            <!--End tables-->
        </div>

    </div>
</template>
<script>
    import Vue from 'vue'
    import VueClipboard from 'vue-clipboard2'
    import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'
    import crc from 'crc'

    Vue.use(VueClipboard);

    export default {
        name: "Crc32",
        directives: {
            'b-tooltip': BTooltipDirective
        },
        data() {
            return {
                select: {
                    out: 'd'
                },
                values: {
                    input: null,
                    output: null
                },
                tableData: [],
            };
        },
        methods: {
            onCopy() {
                this.$notify({
                    type: 'success',
                    title: 'Copied to clipboard'
                })
            },
            revert: function () {

            },
            clean: function () {
                this.values.output = null;
                this.values.input = null;
                this.tableData = [];
            },
            calc: function () {
                if (this.values.input) {
                    let ct = 'dec'
                    if (this.select.out === 'd') {
                        this.values.output = crc.crc32(this.values.input).toString(10);
                    }

                    if (this.select.out === 'h') {
                        this.values.output = '0x' + crc.crc32(this.values.input).toString(16);
                        ct = 'hex'
                    }

                    this.tableData.unshift({
                        input: this.values.input,
                        inType: "text",
                        output: this.values.output,
                        outType: "crc32" + ct,
                    });

                    if (this.tableData.length > 8) {
                        this.tableData.splice(8, 1);
                    }
                }
            }
        },
        mounted() {

        }
    };
</script>
<style></style>
